import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';

import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { IEquipmentTransfer, TransferStatus } from '@services/registrations/registrations.models';

import { DialogService } from '@services/dialog/';
import { RegistrationsService } from '@services/registrations';

import { ViewTransferDetailsComponent } from './../view-transfer-details/view-transfer-details.component';
// import { ViewBikeDetailsComponent } from './../view-bike-details/view-bike-details.component';

@Component({
	selector: 'app-registrations-list',
	templateUrl: './registrations-list.component.html',
	styleUrls: ['./registrations-list.component.scss']
})
export class RegistrationsListComponent implements OnInit, AfterViewInit {

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatTable) table: MatTable<any>;

	@Input() list: IEquipmentTransfer[];
	public paginated: IEquipmentTransfer[] = [];

	public pageIndex = 0;
	public pageSize = 10;
	public tableColumns: string[] = ['id', 'createdAt', 'bikeId', 'sourceRegistrationId', 'destinationEmail', 'status'];

	constructor(
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
		this.sortList('createdAt', 'desc');
	}

	public ngAfterViewInit(): void {
		// Temporary arrangement to let the table load with data, before which we can subscribe to changes to sort field/order
		// TODO: Review this to check if there's a better alternative.
		setTimeout(() => {
			this.subscribeToTableChanges();
		}, 2000);
	}

	private subscribeToTableChanges(): void {
		this.sort.sortChange.subscribe((value: { active: string; direction: string }) => {
			this.paginator.pageIndex = 0;
			this.sortList();
		});
	}

	private sortList(active = this.sort.active, direction = this.sort.direction.toString()): void {
		this.list.sort((a, b) => {
			const aValue = a[active] ? a[active] : '';
			const bValue = b[active] ? b[active] : '';

			return direction === 'desc'
				? bValue?.localeCompare(aValue)
				: direction === 'asc'
				? aValue?.localeCompare(bValue)
				: a.destinationEmail.localeCompare(b.destinationEmail);
		});

		this.paginateRequests(null, true);

		if (this.table) this.table.renderRows();
	}

	public paginateRequests(event: PageEvent, resetPageIndex = false): void {
		this.pageIndex = resetPageIndex || event?.pageSize !== this.pageSize ? 0 : event ? event.pageIndex : this.pageIndex;
		this.pageSize = event ? event.pageSize : this.pageSize;

		this.paginated = this.list
			.slice(this.pageIndex * this.pageSize, this.pageIndex * this.pageSize + this.pageSize);
	}

	public viewTransferDetails(request: any): void {
		this.dialogService.open(ViewTransferDetailsComponent, {
			data: {
				request: request,
				callback: (requestId: string) => {
				}
			}
		});
	}

	// public viewBikeDetails(id: string): void {
	// 	console.log('RegistrationsListComponent - viewBikeDetails: ', id);
	// 	this.dialogService.open(ViewBikeDetailsComponent, {
	// 		data: {
	// 			bikeid: id,
	// 			callback: (requestId: string) => {
	// 			}
	// 		}
	// 	});
	// }
}
